import { ReportTimeIntervalType } from '@vision/ui/enums';
import { ReportChartConfiguration } from '@vision/ui/interfaces';
import { FeedbackBasedQuestionBasedMeasureRenderer, TrendChart2CompareRenderer } from '../../components';
import {
  DefaultReportChartThemeFont,
  DefaultReportChartThemeSeries,
  extendDefaultChartValidationSchema,
} from '../default-chart.config';
import { TrendChart2Measures } from './trend-chart2.measures';

export const TrendChart2DefaultConfiguration: ReportChartConfiguration = {
  supportsLegendSettings: true,
  validationSchema: extendDefaultChartValidationSchema({
    withFeedbackBasedQuestionBased: true,
  }),
  measures: TrendChart2Measures,
  compareRendererComponent: TrendChart2CompareRenderer,
  measureRendererComponent: FeedbackBasedQuestionBasedMeasureRenderer,
  customize: {
    active: (values) => values.selectedMeasure && values.selectedCompare.length > 0,
    timeInterval: ReportTimeIntervalType.DAY,
    peakDefinition: {
      active: true,
      values: [], // { key: '', value: [] as unknown as DatesRangeValue }
    },
    limits: {
      upperLimitActive: false,
      upperLimit: 0,
      lowerLimitActive: false,
      lowerLimit: 0,
    },
    transactionalDate: {
      active: false,
    },
    feedbackCount: {
      active: false,
    },
  },
  defaultTheme: {
    active: (values) => values.selectedMeasure && values.selectedCompare.length > 0,
    title: {
      ...DefaultReportChartThemeFont,
      label: '',
    },
    xAxis: {
      ...DefaultReportChartThemeFont,
    },
    yAxis: {
      ...DefaultReportChartThemeFont,
      activeDisplayFormat: true,
      displayFormat: 'auto',
      minMaxValue: {
        minValue: null,
        maxValue: null,
      },
    },
    dataLabels: {
      ...DefaultReportChartThemeFont,
      active: false,
      displayFormat: 'auto',
      roundingMethod: 'default',
      position: 'top',
    },
    serieDot: {
      active: false,
      symbolSize: 6,
      symbolType: 'circle',
      symbolFilling: 'full',
    },
    series: {
      ...DefaultReportChartThemeSeries,
    },
  },
};
